define('shared/util/dispatchers/FormDataDispatcher',['shared/util/dispatchers/DataDispatcher', 'shared/lib/ctor'], 
function (DataDispatcher, ctor) {
    var Ctor = ctor(function ($el){

        this.base.apply( this, arguments );

        if ( $el.prop('tagName') !== 'FORM' ) {
            throw new Error('Expect a form');
        }

        this.$form = $el;

    }).inherit(DataDispatcher);

    return Ctor;
});
